<template>
  <div>
    <Header />

    <div class="container-fluid users-container">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <AdminSidebar />
        </div>

        <transition appear name="fade">
          <div class="col-md-9 right-container">
            <div class="col-md-12 pt-4">
              <!--  -->
              <h4>Generate Excel Report</h4>

              <router-link
                class="d-block"
                :to="{ name: 'GenerateExcelReport' }"
              >
                Want To Generate Another Report
              </router-link>
              <br /><br />
              <a href="#" @click="downloadExcelFile">
                Click Here To Download XLS Report
              </a>

              <!--  -->
            </div>
          </div>
        </transition>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import AdminSidebar from "@/views/admin/AdminSidebar.vue";
import { fileDownload } from "@/utilities/downloadFile.js";

export default {
  name: "GenerateExcelReport",
  data() {
    return {};
  },
  components: {
    AdminSidebar,
    Header,
    Footer,
  },

  computed: {
    getExcelFileData() {
      return this.$store.getters["generateExcel/getExcelFileData"];
    },
  },

  methods: {
    setActiveMenuItem: function() {
      this.$store.dispatch("adminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "reportsGenerateExcelReport",
        activeMenu: this.activeMenu ? this.activeMenu : "reports",
      });
    },

    downloadExcelFile() {
      try {
        fileDownload(this.getExcelFileData);
      } catch (error) {
        console.log(error);
      }
    },
  },

  created() {
    this.setActiveMenuItem();
  },
};
</script>

<style lang="scss" scoped>
.users-container {
  min-height: 100%;
  margin: -14px 0 0 0;
}
</style>
